<template>
  <v-flex>
    <v-select
      v-model="selectedSupplierType"
      :items="supplierTypesArray"
      item-text="name"
      item-value="id"
      :label="label"
      @change="onChange"
    >
    </v-select>
  </v-flex>
</template>

<script>
  export default {
    name: "SupplierType",

    data(){
      return{
        label: this.filter.label,
        supplierTypesArray: [
          {name: "Travel",id: "1"},
          {name: "Accommodation",id: "3"},
          {name: "Activity",id: "4"},
          {name: "Other",id: "5"},
          {name: "Transport",id: "6"},
        ],
        selectedDepartments: [],
        selectedSupplierType:""
      }
    },

    methods:{
      onChange() {
        this.$emit("onSelect",this.selectedSupplierType);
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gt/shared/SupplierType.vue